import styled from 'styled-components';
import { CaretRightOutlined, CaretLeftOutlined } from '@ant-design/icons';

type WrapperProps = {
  $collapsed: boolean;
};

export const Wrapper = styled.div<WrapperProps>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  width: ${props => (props.$collapsed ? '0' : '250px')};
  height: 100vh;

  border-right: 1px solid #ddd;
  position: fixed;
  overflow: hidden;
  transition:
    width 0.2s,
    visibility 0.2s linear 0.2s;
  visibility: ${props => (props.$collapsed ? 'hidden' : 'visible')};
  z-index: 10;

  .ant-menu {
    height: 100%;
    .ant-menu-item {
      font-size: 15px;
      font-weight: 500;
      padding: 15px 0 15px 5px;
    }
  }
`;

export const CommonLabel = styled.div`
  height: 55px;
  padding: 30px 20px 0 20px;
  color: #b8b8c9;
  font-size: 15px;
`;

export const AdminLabel = styled.div`
  height: 55px;
  padding: 30px 20px 10px 20px;
  color: #b8b8c9;
  font-size: 15px;
`;

export const MenuItem = styled.div`
  padding: 20px 30px;

  color: #333;
  &:hover {
    background-color: #f5f5f5;
  }
  margin: 8px 0;
`;

export const ToggleButton = styled.button<{ $collapsed: boolean }>`
  position: fixed;
  width: 20px;
  height: 50px;
  top: 50%;
  left: ${props => (props.$collapsed ? '0' : '250px')};
  transform: translateY(-50%);
  transition: left 0.2s;
  z-index: 11;
  cursor: pointer;
  border-right: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  border-top: 1px solid #ddd;

  border-radius: 0 5px 5px 0;
  overflow: hidden;
  background-color: white;
`;

export const CustomRightSquareOutlined = styled(CaretRightOutlined)`
  font-size: 15px;
  background-color: white;

  &:hover {
    color: #485af9;
  }
`;

export const CustomLeftSquareOutlined = styled(CaretLeftOutlined)`
  font-size: 15px;
  background-color: white;

  &:hover {
    color: #485af9;
  }
`;

export const LogOut = styled.div`
  padding: 20px 30px;
  font-size: 16px;
`;
